import { MouseEventHandler, ReactNode } from 'react';

import { VideoSize } from 'types/Video/VideoSize';
import { useVideoSize } from 'utils/video';

import {
  VideoThumbnailButtonContainer,
  VideoThumbnailDivContainer,
} from './VideoThumbnailContainer.styled';

type Props = {
  children: ReactNode;
  size: VideoSize;
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export function VideoThumbnailContainer({ children, size, onClick }: Props) {
  const { width, height } = useVideoSize(size);

  if (onClick) {
    return (
      <VideoThumbnailButtonContainer
        type="button"
        onClick={onClick}
        style={{ width, height }}
      >
        {children}
      </VideoThumbnailButtonContainer>
    );
  }

  return (
    <VideoThumbnailDivContainer style={{ width, height }}>
      {children}
    </VideoThumbnailDivContainer>
  );
}
